import { FaFilter } from "react-icons/fa";
import styles from "../table.module.css";
import HoverToolTip from "../../../../../Common/ToolTips/HoverToolTips/HoverToolTip";
import FilterWithPercentage from "./FilterWithPercentage";
import FilterWithOrder from "./FilterWithOrder";
import { useState } from "react";
import FooterButtons from "./FooterButtons";
const ColumnFilterTooltip = ({ item }) => {
  const [filterType, setFilterType] = useState("A-Z");

  const renderFilter = () => {
    switch (filterType) {
      case "A-Z":
        return applySort(item?.values, (a, b) =>
          a?.value.localeCompare(b.value)
        );

      case "Z-A":
        return applySort(item?.values, (a, b) =>
          b?.value.localeCompare(a.value)
        );

      case "Percentage":
        return <FilterWithPercentage item={item} />;
    }
  };

  const applySort = (data, comparator) => {
    const sortedValues = data?.slice()?.sort(comparator);
    for (let val of sortedValues) {
      val.id = item?.mediaBreakdownId;
      val.breakDownName = item?.breakDownName;
    }
    const updatedItem = { ...item, values: sortedValues };
    return <FilterWithOrder item={updatedItem} />;
  };

  return (
    <>
      <p className="mr-ll">{item.breakDownName}</p>
      <div className={`${styles.filterToolTipContainer}`}>
        <HoverToolTip
          content={
            <>
              <div className={styles.filterContainer}>{renderFilter()}</div>
              <FooterButtons
                filterType={filterType}
                setFilterType={setFilterType}
              />
            </>
          }
          variant="large"
          showToolTip={true}
          trigger={"click"}
        >
          <FaFilter size={25} className="black pointer" />
        </HoverToolTip>
      </div>
    </>
  );
};

export default ColumnFilterTooltip;
